// Modules
import { useLocation } from 'react-router-dom'

// Components
import IbanForm from './IbanForm'
import CardForm from './CardForm'

const RCProPayment = () => {
  const { state } = useLocation()

  return state.paymentChoice === 'IBAN'
    ? <IbanForm state={state} />
    : <CardForm state={state} />
}

export default RCProPayment
